// extracted by mini-css-extract-plugin
var _1 = "Rating-modulehoverRow__UYuzF";
var _2 = "Rating-moduleicon__D0T6C";
var _3 = "Rating-modulenoInteractable__JsBCz";
var _4 = "Rating-modulerating__S8hVS";
export { _1 as "hoverRow", _2 as "icon", _3 as "noInteractable", _4 as "rating" }
